export const CHAT_TOKEN_KEY = 'chatToken';

// Full WS URL required per environment
// No hardcoded default: missing env means realtime stays disconnected.
export const getCentrifugoWsUrl = () =>
  String(process.env.REACT_APP_CENTRIFUGO_WS_URL || '').trim();

export const getChatToken = () => localStorage.getItem(CHAT_TOKEN_KEY) || '';

export const clearChatToken = () => localStorage.removeItem(CHAT_TOKEN_KEY);

// Shared building/org/search filters for chat list + unread requests.
export const chatScopeParams = ({ building, org, q } = {}) => {
  const params = {};
  if (Number(building) > 0) params.building = Number(building);
  if (Number(org) > 0) params.org = Number(org);
  if (q) params.q = q;
  return params;
};

export const chatErrorMessage = (err, fallback) =>
  err?.data?.error || err?.data?.message || err?.message || fallback;

export const isBuildingChatEnabled = (building) => !!building?.config?.enable_chat;

export const resolveBuildingList = (allBuildings, buildings) =>
  (Array.isArray(allBuildings) && allBuildings.length > 0
    ? allBuildings
    : Array.isArray(buildings)
      ? buildings
      : []);
